/**
 * readViaApi — pull list changes through our own domain when the browser is
 * blocking Firestore's Listen channel. Walter 2026-08-21; plan:
 * `docs/proposals/2026-08-20-surviving-content-blockers.md`.
 *
 * Companion to saveViaApi (the write half). Used ONLY while lib/readHealth
 * says reads are dead, so an unblocked user never polls and pays nothing.
 */

import { auth } from './firebase';
import { reviveTimestamps } from './reviveTimestamps';

const ENDPOINT = '/api/listChanges';
const TIMEOUT_MS = 12000;

/**
 * fetchListChanges → { lists, serverMs } | null
 * `null` means "couldn't fetch" (blocked here too, offline, functions down) —
 * callers should simply keep whatever they already have.
 */
export async function fetchListChanges({ ownerUid, boardId, sinceMs }) {
  try {
    const user = auth.currentUser;
    if (!user || !ownerUid || !boardId) return null;
    const token = await user.getIdToken();
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ ownerUid, boardId, sinceMs: sinceMs || 0 }),
      cache: 'no-store',
      signal: AbortSignal.timeout ? AbortSignal.timeout(TIMEOUT_MS) : undefined,
    });
    if (!res.ok) return null;
    const data = await res.json().catch(() => null);
    if (!data || !data.ok || !Array.isArray(data.lists)) return null;
    return { lists: data.lists.map(reviveTimestamps), serverMs: data.serverMs || Date.now() };
  } catch (_) {
    return null;
  }
}
